import React from 'react';

// Types
export interface Props {}

const LoadingSkeleton: React.FC<Props> = ({}) => {
    return (
        <div className="flex animate-pulse flex-col items-center">
            <div className="h-8 w-1/2 rounded-2xl bg-gray-200" />
            <div className="mt-4 h-8 w-3/4 rounded-2xl bg-gray-200" />
            <div className="mt-8 h-3 w-3/4 rounded-lg bg-gray-200" />
            <div className="mt-4 h-3 w-full rounded-lg bg-gray-200" />
            <div className="mt-4 h-3 w-1/2 rounded-lg bg-gray-200" />
            <div className="mt-12 aspect-video w-80 rounded-lg bg-gray-200" />
        </div>
    );
};

export default LoadingSkeleton;
